export const IS_PREVIEW = process.env.NEXT_PUBLIC_IS_PREVIEW === 'PREVIEW';
